var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortnite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fortnite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7425 3.72041H3.49422C3.21103 3.72041 2.94494 3.84127 2.75693 4.05534C2.574 4.26847 2.49166 4.54789 2.53166 4.82356L2.53244 4.82823L2.53316 4.8325L3.32258 7.67184L2.6389 14.7937C2.61882 15.1051 2.75038 15.4059 2.99273 15.6044C3.17312 15.7464 3.39546 15.8206 3.61021 15.8206C3.69994 15.8206 3.78562 15.8091 3.86075 15.7886L3.86554 15.7873L6.7425 15.0563V17.225C6.7425 17.4607 6.85387 17.6837 7.04422 17.8267C7.17825 17.9271 7.33962 17.9796 7.50265 17.9796C7.57242 17.9796 7.64294 17.97 7.71242 17.9504C7.71247 17.9504 7.71254 17.9503 7.71262 17.9503L10.703 17.1006C11.0299 17.0076 11.2539 16.7109 11.2539 16.375V14.8015L16.4066 15.322C16.6978 15.3523 16.9808 15.251 17.1858 15.0444L17.1884 15.0419L17.1908 15.0395C17.3992 14.835 17.5014 14.5516 17.4738 14.2659V14.265L16.8077 7.2449L17.3054 4.93126L17.3074 4.92316C17.3801 4.63113 17.3155 4.32951 17.1308 4.0963L17.1298 4.09514L17.1289 4.09399C16.9414 3.85467 16.6659 3.72041 16.3608 3.72041H14.0646L14.2294 2.92876C14.276 2.7074 14.2196 2.47609 14.0753 2.29953C13.9311 2.12313 13.7143 2.02041 13.4849 2.02041H7.50265C7.08136 2.02041 6.7425 2.35958 6.7425 2.775V3.72041ZM7.85484 18.451C7.73904 18.4837 7.62058 18.5 7.50265 18.5C7.22748 18.5 6.95586 18.4114 6.73068 18.2427C6.40978 18.0017 6.22075 17.6249 6.22075 17.225V15.7259L3.99913 16.2903C3.8752 16.3243 3.74268 16.341 3.61021 16.341C3.27692 16.341 2.93896 16.2266 2.66548 16.0097C2.28946 15.7038 2.08466 15.2359 2.11884 14.7514L2.79401 7.71811L2.03288 4.98051C2.02498 4.95694 2.02107 4.93347 2.01715 4.9099C2.01683 4.90799 2.01651 4.90607 2.01619 4.90416C1.95209 4.4749 2.08052 4.0419 2.36254 3.71464C2.64883 3.3874 3.05837 3.2 3.49422 3.2H6.22075V2.775C6.22075 2.07078 6.79462 1.5 7.50265 1.5H13.4849C13.8707 1.5 14.2361 1.67273 14.4797 1.97065C14.6466 2.1748 14.7441 2.42281 14.7636 2.67959C14.7725 2.79756 14.7649 2.91738 14.74 3.03564L14.7058 3.2H16.3608C16.8266 3.2 17.2537 3.40809 17.54 3.77359C17.8263 4.13483 17.9248 4.60233 17.8138 5.04859L17.3347 7.27569L17.9931 14.216C18.036 14.658 17.8773 15.0959 17.5567 15.4104C17.2405 15.7292 16.8011 15.8863 16.3524 15.8396L11.7756 15.3772V16.375C11.7756 16.9441 11.3963 17.4446 10.8459 17.601L7.85484 18.451Z",
    fill: "url(#paint0_linear_3420_139028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.25835 2.5C7.25835 2.5 7 2.6006 7 2.72468V17.2753C7 17.3469 7.0391 17.414 7.1053 17.4564C7.17151 17.4988 7.25694 17.511 7.33537 17.4898L10.3679 16.6659C10.4758 16.6367 10.5492 16.5499 10.5492 16.4515V11.1876H13.0879C13.2305 11.1876 13.3462 11.087 13.3462 10.9629V8.07954C13.3462 7.95546 13.2305 7.85486 13.0879 7.85486H10.5492V5.83275H13.0742C13.1973 5.83275 13.3032 5.7573 13.3275 5.6524L13.9949 2.76901C14.0102 2.70297 13.9906 2.63446 13.9415 2.58234L13.7416 2.5H7.25835Z",
    fill: "url(#paint1_linear_3420_139028)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3420_139028",
    x1: 10,
    y1: 1.5,
    x2: 10,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5589E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7773D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3420_139028",
    x1: 10.5,
    y1: 2.5,
    x2: 10.5,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5589E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7773D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortnite);
export default __webpack_public_path__ + "static/media/fortnite.03356f76f42355676363aa42c4b3848c.svg";
export { ForwardRef as ReactComponent };